import $ from "jquery"
import stringUtils from "./string_utils.js"

let lang


function init (translations, newLang) {
    translate.translations = translations
    lang = newLang
}



function translateHtml () {
    $("[data-translation]").each(function (index, element) {
        let key = $(element).attr("data-translation")
        $(element).text(translate(key))
    })
}



function translate (key, data, {absenceExpected = false} = {}) {
    if (!translate.translations) {
        console.warn("Translations are not initialized")
        return key
    }
    let translation = translate.translations[key]

    if (translation && typeof translation[lang] !== "undefined") {
        let value = translation[lang]
        if (data) {
            value = stringUtils.interpolate(value, data)
        }
        return value
    }

    if (!absenceExpected) {
        console.warn(`Translation missing for ${key}`)
    }

    return key
}


translate.init = init
translate.translateHtml = translateHtml


export default translate

